import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", null, " © Copyright " + _toDisplayString(_ctx.currentYear) + " BMW Group | BMW International Feedback Management Tool | Version " + _toDisplayString(_ctx.version), 1)
  ]))
}